import React from 'react';

import { usePathname } from 'expo-router';

import { OrderProcessingLoading } from 'components/order-processing-loading';
import { useEnableOrderPendingProcessModalExperiment } from 'experiments/use-order-pending-process-modal-experiment';
import { useRecoverPendingSubmittedOrder } from 'hooks/use-recover-pending-submitted-order';
import { useShouldShowOrderRecoveryLoading } from 'utils/order/pending-submitted-order';
import { routes } from 'utils/routing';

interface PendingSubmittedOrderRecoveryProps {
  checkoutRoute?: string | null;
}

export const PendingSubmittedOrderRecovery = ({
  checkoutRoute = null,
}: PendingSubmittedOrderRecoveryProps) => {
  const pathname = usePathname();
  const isOrderPendingProcessModalEnabled = useEnableOrderPendingProcessModalExperiment();
  const shouldShowOrderRecoveryLoading = useShouldShowOrderRecoveryLoading();

  useRecoverPendingSubmittedOrder({
    checkoutRoute,
    enabled: isOrderPendingProcessModalEnabled,
  });

  if (
    !isOrderPendingProcessModalEnabled ||
    !shouldShowOrderRecoveryLoading ||
    pathname.startsWith(routes.orderConfirmation) ||
    pathname.startsWith(routes.cartPayment) ||
    pathname.startsWith(routes.cartCheckout)
  ) {
    return null;
  }

  return <OrderProcessingLoading testID="pending-submitted-order-processing" />;
};
